import styled, { css } from 'styled-components';

export const PartPayWrap = styled.div`
  position: relative;
  z-index: 1;
  margin-left: 10px;
  &.moving-border {
    position: relative;
    background: #fff;

    border-radius: 44px;
    @property --angle {
      syntax: '<angle>';
      initial-value: 0deg;
      inherits: false;
    }

    &:after {
      content: '';
      position: absolute;
      inset: -0.1rem;
      z-index: -1;
      border-radius: 44px;
      background: linear-gradient(var(--angle), #1149f3, #1149f3, #1149f3, #fff, #fff);
      animation: rotate 2s linear forwards;
    }

    @keyframes rotate {
      0% {
        --angle: 0deg;
      }
      100% {
        --angle: 360deg;
        background: linear-gradient(45deg, #1149f3, #1149f3, #1149f3, #fff, #fff);
      }
    }
  }

  ${props =>
    props.review &&
    css`
      margin-left: 0;
    `}
`;
export const PartPayContain = styled.div`
  background: ${props =>
    props.bgClr?.length > 1
      ? `linear-gradient(135deg, ${props.bgClr[0]} 0%, ${props.bgClr[1]} 100%)`
      : 'linear-gradient(135deg, #e5f3ff 0%, rgba(255, 255, 255) 100%)'};
  padding: 4px 10px;
  border-radius: 44px;
  border: 1px solid ${props => (props.borderClr?.length ? props.borderClr[0] : '#efefef')};
`;

export const NewTag = styled.span`
  background-color: #ff3a5b;

  border-radius: 5px;
  position: absolute;
  top: -8px;
  left: 10px;
  width: 33px;
`;

export const AnimatedImg = styled.img`
  animation: moveText 2s linear 2;
  overflow: hidden;
  position: relative;
  color: #ffffff;
  line-height: 1;
  padding: 0px 3px 2px;

  @keyframes moveText {
    0% {
      text-indent: -40px;
      opacity: 0.3;
    }
    80% {
      text-indent: 0;
      opacity: 1;
    }
  }
`;

export const Tooltiptext = styled.div`
  visibility: hidden;
  min-width: 280px;
  background-color: ${props => (props.bgClr?.length ? props.bgClr[0] : '#222222')};
  border-radius: 5px;
  color: #fff;
  padding: 8px 15px;
  position: absolute;
  z-index: 1;
  transform: translateY(-64%);
  left: 34px;

  &:after {
    content: '';
    position: absolute;
    top: 48%;
    right: 100%;
    margin-top: -8px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent #222 transparent transparent;
    ${props =>
      props.bottom &&
      css`
        bottom: 100%;
        left: 76%;
        top: auto;
        right: auto;
        margin-top: auto;
        margin-left: 6px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent black transparent;
      `}
  }
  ${props =>
    props.review &&
    css`
      top: 30px;
      left: -70px;
      padding: 15px;
      color: '#fffff';
      transform: translateX(-50%);
    `}
`;

export const ToolTip = styled.div`
  position: relative;
  display: inline-block;
  &:hover ${Tooltiptext} {
    visibility: visible;
  }
`;

export const PayOptionList = styled.ul`
  margin-left: 20px;
  li {
    padding-bottom: 5px;
  }
`;
